import { render, staticRenderFns } from "./NbaNewsComponent.vue?vue&type=template&id=279aa0d0"
import script from "./NbaNewsComponent.vue?vue&type=script&lang=js"
export * from "./NbaNewsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports